"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduledTxnsToRender = exports.matchesScheduledTxnSearch = exports.getScheduledTxnDueState = exports.isScheduledTxnSelected = exports.findInitialValueForBillsScout = void 0;
const luxon_1 = require("luxon");
const scheduledTransactionsTypes_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsTypes");
const scheduledTransactionsUtils_1 = require("data/scheduledTransactions/scheduledTransactionsUtils");
const TagsField_1 = require("components/QuickenControls/TagsField");
const ScheduleTransactionSelector_1 = require("components/Dialogs/WfBillScout/ScheduleTransactionSelector");
const findInitialValueForBillsScout = (filterTab) => {
    switch (filterTab) {
        case scheduledTransactionsTypes_1.STTypeEnum.INCOME:
            return ScheduleTransactionSelector_1.INCOME_STEP;
        case scheduledTransactionsTypes_1.STTypeEnum.EXPENSE:
            return ScheduleTransactionSelector_1.BILLS_STEP;
        default:
            return ScheduleTransactionSelector_1.ALL_STEP;
    }
};
exports.findInitialValueForBillsScout = findInitialValueForBillsScout;
const isScheduledTxnSelected = (scheduledTxn, uiTxn) => uiTxn &&
    ((!scheduledTxn.clientId && uiTxn.id === scheduledTxn.id) ||
        (uiTxn.clientId && uiTxn.clientId === scheduledTxn.clientId));
exports.isScheduledTxnSelected = isScheduledTxnSelected;
const getScheduledTxnDueState = (dueOn) => {
    const isDue = luxon_1.DateTime.fromISO(dueOn) <= luxon_1.DateTime.local();
    const isOverdue = isDue && luxon_1.DateTime.fromISO(dueOn).toISODate() !== luxon_1.DateTime.local().toISODate();
    return {
        isDue,
        isOverdue,
        showLabel: isDue || isOverdue,
    };
};
exports.getScheduledTxnDueState = getScheduledTxnDueState;
const matchesScheduledTxnSearch = ({ scheduledTxn, globalSearch, allUpcomingTxns, categoriesById, accountsById, tags, }) => {
    if (!globalSearch) {
        return true;
    }
    const upTxn = allUpcomingTxns.get(scheduledTxn && scheduledTxn.id);
    const schTxn = (0, scheduledTransactionsUtils_1.userFriendlyTxnNames)(scheduledTxn, categoriesById, accountsById, upTxn && upTxn.first());
    schTxn.amount = schTxn.amount.toString();
    schTxn.tags = (0, TagsField_1.makeTagNameArray)(tags, scheduledTxn.transaction.tags);
    return Object.keys(schTxn).some((txn) => schTxn[txn] && schTxn[txn].toLowerCase().includes(globalSearch));
};
exports.matchesScheduledTxnSearch = matchesScheduledTxnSearch;
const getScheduledTxnsToRender = ({ scheduledTransactions, filterTab, sortDueDate, globalSearch, allUpcomingTxns, categoriesById, accountsById, tags, }) => scheduledTransactions.toIndexedSeq()
    .filter(({ type, isCompleted }) => !isCompleted && (filterTab === scheduledTransactionsTypes_1.STTypeEnum.INCOME
    ? type === scheduledTransactionsTypes_1.STTypeEnum.INCOME || type === 'GROSS_PAYCHECK'
    : filterTab === 'all' || filterTab === type))
    .sort((scheduledTransaction1, scheduledTransaction2) => {
    const schTxn1Payee = scheduledTransaction1.transaction.payee || '';
    const schTxn2Payee = scheduledTransaction2.transaction.payee || '';
    if (sortDueDate) {
        return scheduledTransaction2.dueOn > scheduledTransaction1.dueOn ? -1 : 1;
    }
    return schTxn1Payee.localeCompare(schTxn2Payee, undefined, {
        numeric: true,
        sensitivity: 'base',
    });
})
    .filter((txn) => (0, exports.matchesScheduledTxnSearch)({
    scheduledTxn: txn,
    globalSearch,
    allUpcomingTxns,
    categoriesById,
    accountsById,
    tags,
}));
exports.getScheduledTxnsToRender = getScheduledTxnsToRender;
